module.exports = __webpack_public_path__ + "static/media/5_nature.7815134c.jpg";